import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import ReactDayPicker from 'react-day-picker';
import moment from 'moment';
import localeUtils from 'utils/datePickerTranslation';

const DayPicker = createClass({
  propTypes: {
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    toRange: PropTypes.object,
    disableDaysAfter: PropTypes.object,
    disableDaysBefore: PropTypes.object
  },

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  },

  componentWillReceiveProps(nextProps) {
    if (!this.props.value && nextProps.defaultMonth) return this.refs.dayPicker.showMonth(nextProps.defaultMonth);
    if (nextProps.value) return this.refs.dayPicker.showMonth(nextProps.value);
  },

  onDayClick(day, {selected, disabled}, evt) {
    if (selected || disabled) return;
    if (this.props.onChange) this.props.onChange(day);
  },

  render() {
    const {value, toRange, disableDaysAfter, disableDaysBefore} = this.props;
    const modifiers = value ? {
      active: originDay => moment(originDay).isSame(value, 'day'),
      range: (originDay) => {
        if (!this.props.toRange) return false;
        const originTime = originDay.getTime();
        const startTime = moment.min(moment(value), moment(toRange)).toDate().getTime();
        const endTime = moment.max(moment(value), moment(toRange)).toDate().getTime();
        return startTime <= originTime && endTime >= originDay;
      }
    } : null;

    return (
      <ReactDayPicker
        enableOutsideDays
        ref='dayPicker'
        modifiers={modifiers}
        onDayClick={this.onDayClick}
        localeUtils={localeUtils}
        disabledDays={(d) => {
          if (!disableDaysAfter && !disableDaysBefore) return false;
          if (disableDaysAfter) return moment(d).isAfter(disableDaysAfter, 'day');
          if (disableDaysBefore) return moment(d).isBefore(disableDaysBefore, 'day');
        }}
      />
    );
  }

});

module.exports = DayPicker;
